/* eslint-disable no-unused-expressions */
import React from 'react';

import './index.scss';
import PublishModalTable from './modalTable';

function modalComponent({modalId, modalData, cancelAction}) {
  return(
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true' data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div className='cb-modal-container submitModal_container' role='dialog' aria-modal='true' aria-labelledby='publishModalTitle' aria-describedby='publishDlgDsc'>
          <div className='cb-modal-header'>
            <h2 className='cb-modal-title submitModal_container-title' id='publishModalTitle'>
              <i className='cb-icon cb-icon-circular cb-exclamation cb-red1-color' aria-hidden='true' />
              <span style={{marginLeft: '20px'}}>We were unable to accept your category.</span>
            </h2>

            {/* <!-- close button --> */}
            <button type='button' onClick={cancelAction} className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby='publishModalTitle' data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-content submitModal_container-content' id='publishDlgDsc'>
            <p>Please fix all errors and accept your category again.</p>
            <div style={{margin: '10px 0px'}}>
              <PublishModalTable modalData={modalData} id={'publish'} />
            </div>
          </div>
          <div className='cb-modal-footer'>
            <div className='cb-btn-row' id='pubBtnRow'>
              <button type='button' onClick={cancelAction} className='cb-btn cb-btn-naked' data-cb-modal-close aria-label='Close'>Close</button>
              {/* <!-- close button --> */}
              {/* <button type='button' className='cb-btn cb-btn-primary' data-cb-modal-close aria-label='Edit Now' onClick={editAction}>Edit Now</button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default modalComponent;